import type { LoadQuoteEpicApi } from 'epic/loadQuote/loadQuoteEpic';
import type { ProcessingChain } from 'models/ProcessingChain';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface IQuoteOrigin {
  screenMode: ScreenMode;
  processingChain: ProcessingChain;
  quoteId: string;
  externalQuoteId: string;
  productId: string;
}

export type ScreenMode = 'Static' | 'Dynamic' | 'NewStatic' | 'NewDynamic' | 'essential';
export type Source = 'Schedule';
export type IQuoteLoadingApi = LoadQuoteEpicApi;

export function quoteLoadingApi(http: IHttpClient): IQuoteLoadingApi {
  return {
    retrieveQuoteOrigin(quoteId: string, source?: Source): Observable<IQuoteOrigin> {
      return http
        .getJSON<IQuoteOrigin>({
          url: `api/v1/quote/${quoteId}/origin`,
          params: { source },
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
